module.exports = __webpack_public_path__ + "static/img/yxdtd-ChzySjJK.98097c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/yxdtd-ChzySjJK.png
// module id = OXAb
// module chunks = 16